import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {STATES_ENTITY} from '../../constants';
import {ChangeEditModeAndState} from '../../types/slices';
import {DataExportModel, DataExportType} from '../../types/DataExport';

type InitialState = {
  isEditMode: boolean,
  dataExportState: string,
  entityValid: boolean,
  dataExports: Array<DataExportModel>
  dataExportTypes: Array<DataExportType>
}

export const DATA_EXPORT_REDUCER = 'dataExportReducer';

const initialState: InitialState = {
  isEditMode: false,
  dataExportState: STATES_ENTITY.NONE,
  entityValid: false,
  dataExports: [],
  dataExportTypes: [],
};

const dataExportSlice = createSlice({
  name: DATA_EXPORT_REDUCER,
  initialState,
  reducers: {
    changeEditModeAndDataExportState(state, action: PayloadAction<ChangeEditModeAndState>) {
      state.isEditMode = action.payload.isEditMode;
      state.dataExportState = action.payload.state;
    },
    changeDataExportValid(state, action: PayloadAction<boolean>) {
      state.entityValid = action.payload;
    },
    setDataExport(state, action: PayloadAction<Array<DataExportModel>>) {
      state.dataExports = action.payload;
    },
    setDataExportTypes(state, action: PayloadAction<Array<DataExportType>>) {
      state.dataExportTypes = action.payload;
    },
  },
});

export const {
  changeEditModeAndDataExportState,
  changeDataExportValid,
  setDataExport,
  setDataExportTypes,
} = dataExportSlice.actions;

export default {name: DATA_EXPORT_REDUCER, reducer: dataExportSlice.reducer};
